<template>
    <div style="height: 100%;">
        <div id="main" v-show="!rotaAninhada">
            <container-loader v-if="isLoading && !$store.getters.isLoading"/>
            <div class="page">
                <!-- Título -->
                <div class="produto vertical-flow">
                    <div class="listing-header">
                        <div class="title-breadcrumb">
                            <h1 class="title">{{ $t("produtos") }}</h1>
                            <nav class="breadcrumb" aria-label="breadcrumbs">
                                <ul>
                                    <li>
                                        <a class="a-inativo">{{
                                            $t("vendas")
                                        }}</a>
                                    </li>
                                    <li>
                                        <a class="a-inativo">{{
                                            $t("cadastros")
                                        }}</a>
                                    </li>
                                    <li>
                                        <a aria-current="page">{{
                                            $t("produtos")
                                        }}</a>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                        <div class="header-buttons">
                            <button
                                v-if="permissao.create && !produtoIntegracao"
                                class="save-btn"
                                type="button"
                                tag="button"
                                @click="
                                    $router.push({ name: 'ven-produto-new' })
                                "
                            >
                                {{ $t("adicionar") }}
                            </button>
                        </div>
                    </div>

                    <div class="filters-bar mb-2">
                        <div class="filters-bar-form form-columns-fit">
                            <div class="columns">
                                <div class="column is-4">
                                    <search-bar
                                        :onSearch="debouncedOnSearch"
                                        tooltipLabel="msg-busca-ven-produto-campos"
                                    />
                                </div>
                                <div
                                    class="column is-4"
                                >
                                    <label for="busca" v-text="$t('empresa')" />
                                    <vss-select
                                        :value="empresaSelecionada"
                                        :options="empresas"
                                        :loading="empresasLoading"
                                        @search="carregarEmpresas"
                                        @input="updateEmpresa"
                                        label="rsocial"
                                        searchable
                                        :selectHeight="40"
                                    />
                                </div>
                                <div
                                    class="column is-4"
                                >
                                    <vss-select
                                        title="tab-preco"
                                        :value="tabPrecoSelecionadas"
                                        :options="tabPreco"
                                        :loading="tabPrecoLoading"
                                        @input="updateTabPreco"
                                        @search="carregarTabPreco"
                                        label="descricao"
                                        :selectHeight="40"
                                        :closeOnSelect="false"
                                        :compareId="true"
                                        no-clearfix 
                                        multiple 
                                        clearable 
                                        searchable
                                        tooltipLabel="msg-tabpreco-empresa"
                                    >
                                        <template #multiple-selected="{ selected }">
                                            ({{ selected && selected.length > 0 ? selected.length : $t('todos') }})
                                        </template>
                                    </vss-select>
                            </div>
                            </div>
                        </div>
                        <div class="filters-bar-actions">
                            <b-button 
                                class="mr-2 float-right"
                                type="is-primary" 
                                icon-right="filter" 
                                @click="showFilter=!showFilter"
                                v-tippy 
                                :title="$t('filtros')"
                            />
                        </div>
                    </div>
                    <!-- FILTROS EXTRAS -->
                    <div class="filtros-extras">
                        <FiltroProduto
                        ref="filtroRef"
                            :empresa="empresaSelecionada ? empresaSelecionada : {}"
                            :isTabPrecoSelected="tabPrecoSelecionadas.length > 0"
                            :showFilter="showFilter"
                            :filtroMostrarFotos="filtros.mostrarFotos"
                            :isLoading="isLoading"
                            @limparFiltros="limparFiltros"
                            @update-filtro="updateFiltro"
                            @showFilter="showFilter = $event"
                            @pesquisar="pesquisar"
                        />
                    </div>
                    <div class="produto-table registry-wrapper">
                        <empty-table-message v-if="isEmpty" />
                        <b-table
                            v-else
                            class="data-table"
                            :data="allprodutos"
                            @sort="sortTable"
                            backend-sorting
                        >
                            <b-table-column
                            v-for="(f, i) in filtros.mostrarFotos && filtros.tipocatalogo != false ? fieldsFotos : fields"
                                :key="i"
                                :field="f.key"
                                :label="f.label"
                                :width="f.width"
                                :sortable="f.sortable"
                            >
                                <template v-slot:header>
                                    <span v-if="f.key == 'foto'">
                                        {{ $t("foto") }}
                                    </span>

                                    <span v-if="f.key == 'idprodutoerp'">
                                        {{ $t("codigo") }}
                                    </span>

                                    <span v-else-if="f.key == 'produtodescricao'">
                                        {{ $t("descricao") }}
                                    </span>
                                    <span v-else-if="f.key == 'empresanome'">
                                        {{ $t("empresa") }}
                                    </span>

                                    <span v-else-if="f.key == 'saldo'">
                                        {{ $t("saldo-estoque") }}
                                    </span>

                                    <span v-else-if="f.key == 'referencia'">
                                        {{ $t("referencia") }}
                                    </span>
                                    
                                    <span v-else-if="f.key == 'marca'">
                                        {{ $t("marca") }}
                                    </span>

                                    <span v-else-if="f.key == 'tabelapreco'">
                                        {{ $t("tabela-preco") }}
                                    </span>

                                    <span v-else-if="f.key == 'valor1'">
                                        {{ $t("valor-produto") }}
                                    </span>

                                    <span v-else-if="f.key == 'codbarras'">
                                        {{ $t("codbarras") }}
                                    </span>
                                    <b-icon
                                        v-if="sort.column==f.key"
                                        :icon="`arrow-${sort.order=='asc'?'up':'down'}`"
                                        size="is-small"
                                    />
                                </template>
                                    <template v-slot="props">
                                        <div class="image-box" v-if="f.key == 'foto'">
                                            <div v-if="props.row[f.key]"
                                                class="image-as-background"
                                                :style="{
                                                    'width': imgWidth + 'px',
                                                    'height': imgHeight + 'px',
                                                }">
                                            <img :src="!isNull(props.row[f.key].url)
                                                ? props.row[f.key].url
                                                : require('@/assets/img/icons/no-image.svg')"
                                                        :style="{
                                                            'height': imgHeight + 'px',
                                                            'width': imgWidth + 'px',
                                                            'object-fit': 'contain'
                                                        }"
                                                        @error="onImageError"/>
                                            </div>
                                        </div>
                                        <div v-else-if="f.key == 'produtodescricao'">
                                        <router-link
                                            :to="{
                                                name: 'ven-produto-edit',
                                                params: { id: props.row.id },
                                            }"
                                        >
                                            {{ props.row[f.key] }}
                                        </router-link>
                                    </div>
                                    <div v-else-if="f.key == 'valor1'">
                                            {{ props.row[f.key] | decimal(null, true) }}
                                    </div>
                                    <div v-else>
                                        {{ props.row[f.key] }}
                                    </div>
                                </template>
                            </b-table-column>
                        </b-table>
                    </div>
                    <PaginationViewer
                        class="mb-0"
                        :resetPagination="pagination.resetPagination"
                        :totalItems="pagination.totalRows"
                        :perPageOptions="pagination.perPageOptions"
                        :optionStarted="pagination.optionStarted"
                        @change="updatePagination"
                    />
                </div>
            </div>
        </div>
        <router-view />
    </div>
</template>

<script>
import FilterBar from "@/components/shared/Filter";
import ProdutoService from "@/services/vendas/produto/ProdutoService";
import ContainerLoader from "@/components/content/loader/ContainerLoader";
import TabPrecoService from "@/services/vendas/tabpreco/TabPrecoService";
import ParametroService from "@/services/vendas/produto/ParametroService";
import FiltroProduto from '@/components/vendas/produto/FiltroProduto';

export default {
    beforeRouteLeave(to, from, next) {
        if (this.$cookies.get('fotos-produto') == undefined) {
            this.$cookies.set('fotos-produto', this.filtros.mostrarFotos);
        }

        next();
    },
    beforeRouteUpdate(to, from, next) {
        if (to.name.includes("ven-produto") && to.name != "ven-produto-list") {
            this.rotaAninhada = true;
            next();
        } else {
            this.rotaAninhada = false;
            next();
        }
    },
    components: {
        FiltroProduto,
        FilterBar,
        ContainerLoader,
    },
    data() {
        return {
            rotaAninhada: false,
            produtoIntegracao:
                this.$store.state.user.tabelasERPWebServer.includes("PRODUTO"),
            allprodutos: [],
            service: new ProdutoService(this.$http, this.$router),
            parametroService: new ParametroService(this.$http, this.$router),
            tabPrecoService: new TabPrecoService(this.$http, this.$router),
            fieldsFotos: [
                { key: "foto", label: "foto", width: null, sortable: false },
                { key: "idprodutoerp", label: "idprodutoerp", width: null, sortable: true },
                { key: "produtodescricao", label: "descricao", width: 500, sortable: true },
                { key: "empresanome", label: "empresa", width: null, sortable: true },
                { key: "saldo", label: "saldo-estoque", width: null, sortable: true },
                { key: "referencia", label: "referencia", width: null, sortable: true },
                { key: "marca", label: "marca", width: null, sortable: true },
                { key: "tabelapreco", label: "tabela-preco", width: null, sortable: true },
                { key: "valor1", label: "valor-produto", width: null, sortable: true },
                { key: "codbarras", label: "codbarras", width: null, sortable: true },
            ],
            fields: [
                { key: "idprodutoerp", label: "idprodutoerp", width: null, sortable: true },
                { key: "produtodescricao", label: "descricao",width: 500, sortable: true },
                { key: "empresanome", label: "empresa", width: null, sortable: true },
                { key: "saldo", label: "saldo-estoque", width: null, sortable: true },
                { key: "referencia", label: "referencia", width: null, sortable: true },
                { key: "marca", label: "marca", width: null, sortable: true },
                { key: "tabelapreco", label: "tabela-preco", width: null, sortable: true },
                { key: "valor1", label: "valor-produto", width: null, sortable: true },
                { key: "codbarras", label: "codbarras", width: null, sortable: true },
            ],
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            filtros: {
                idempresa: null,
                idtabpreco: "",
                grupos: [],
                subgrupos: [],
                linhas: [],
                fornecedores: [],
                referencia: '',
                complemento: '',
                search: '',
                bonificacao: 2,
                promocao: 2,
                kitCombo: 2,
                situacao: 2,
                catalogo: 2,
                tabelaPreco: 2,
                mostrarFotos: true,
            },
            isLoading: false,
            isEmpty: true,
            isOrdering: false,
            modalOpen: false,
            allowDelete: false,
            sort: {
                order: "asc",
                column: "PRODUTODESCRICAO",
            },
            
            debouncedOnSearch: null,
            permissao: {},
            tabPreco: [],
            tabPrecoSelecionadas: [],
            tabPrecoLoading: false,
            empresas: [],
            empresaSelecionada: null,
            empresasLoading: false,
            imgHeight: null,
            imgWidth: null,
            showFilter: false,
            reloadTable: false,
        };
    },
    created() {
        this.rotaAninhada =  (
            this.$route.name.includes("ven-produto") &&
            this.$route.name != "ven-produto-list"
        );

        let cookie = this.$cookies.get('fotos-produto');
        if (cookie != undefined) {
            this.filtros.mostrarFotos = cookie === 'true';
        }

        this.pagination.perPage =
            this.pagination.perPageOptions[this.pagination.optionStarted];
        this.permissao = this.hasPermissionAccess(
            "vendas",
            "produtos",
            "ven-produto"
        );
        !this.permissao.read &&
            this.$router.push({
                name: "acesso-nao-permitido",
                params: { tela: "produtos" },
            });
        this.debouncedOnSearch = this.debounce(this.onSearch, 500);
    },
    methods: {
        sortTable(field, order) {
            this.sort.column = field;
            this.sort.order = order;
            this.carregarDados(1, true);
        },
        getThumbnailSize(isInput=false) {
            this.isLoading = true;
            this.parametroService
                .findParametroByNome("DIMENSAO_IMAGEM_THUMBNAIL_WEB")
                .then((body) => {
                    this.imgWidth = null;
                    this.imgHeight = null;
                    if (body && body.content) {
                        this.imgWidth = body.content.valor.toLowerCase().split("x")[0];
                        this.imgHeight = body.content.valor.toLowerCase().split("x")[1];
                    }
                    if(!this.imgWidth){
                        this.imgWidth = 112;
                    }
                    if(!this.imgHeight){
                        this.imgHeight = 112;
                    }
                })
                .catch((e) => {
                    this.imgWidth = 112;
                    this.imgHeight = 112;
                    console.error(`Erro ao realizar pesquisa.`, e)
                })
                .finally(() => {
                    this.carregarDados(1, isInput)
                })

        },
        limparFiltros(clear) {
            this.showFilter = clear;
            setTimeout(() => {
                this.carregarDados(1, true);
            }, 1000);
        },
        updateFiltro(filtro) {
            if(filtro.nomeFiltro == 'mostrarFotos') {
                this.reloadTable = (this.filtros.mostrarFotos != filtro.valor);
            }
            this.filtros[filtro.nomeFiltro] = filtro.valor;
        },
        pesquisar(search) {
            this.showFilter = search;
            setTimeout(() => {
                this.carregarDados(1, true);
            }, 1000);
        },
        onImageError(event){
            event.target.src = require('@/assets/img/icons/no-image.svg')
        },
        // EMPRESAS
        carregarEmpresas(q) {
            this.empresasLoading = true
            if (this.$store.state.user.admin) {
                /* objeto window.empresas */
                this.empresas = this.$store.state.empresas.data.filter((e) => {
                    return e.rsocial
                        .toLocaleUpperCase()
                        .includes(q.toLocaleUpperCase());
                });
            } else {
                this.empresas = this.$store.state.user.empresas.filter((e) => {
                    return e.rsocial
                        .toLocaleUpperCase()
                        .includes(q.toLocaleUpperCase());
                });
            }
            // @84559 - Faz o sort das empresas por ordem alfabética (considerando razão social)
            this.empresas.sort((a, b) => {
                let fa = a.rsocial.toLocaleUpperCase(),
                    fb = b.rsocial.toLocaleUpperCase();
                if (fa < fb) {
                    return -1;
                }
                if (fa > fb) {
                    return 1;
                }
                return 0;
            });
            this.empresas.unshift({id: 0, rsocial: "Sem vínculo"})
            if(this.$store.state.user.admin || this.$store.state.empresas.data.length === this.$store.state.user.empresas.length){
                this.empresas.unshift({id: -1, rsocial: "Todos"})
            }
            this.empresaSelecionada = this.empresas[0];
            this.filtros.idempresa = this.empresaSelecionada.id ? this.empresaSelecionada.id : 0
            this.empresasLoading = false
            this.carregarTabPreco('', true);
        },
        // @84559 - Ao selecionar uma empresa, carrega todos os produtos associados a esta e atualiza as tabelas de preço
        updateEmpresa(e) {
            this.empresaSelecionada = e;
            this.filtros.idempresa =  this.empresaSelecionada.id ? this.empresaSelecionada.id : 0;
            this.carregarTabPreco('', true);
        },
        // TABELA DE PRECO
        carregarTabPreco(search = '', isInput=false) {
            if(this.empresasLoading) return;

            this.tabPrecoSelecionadas = [];
            this.tabPrecoLoading = true;
            let idempresa = this.empresaSelecionada.id >= 1 ? "0, " + this.empresaSelecionada.id : this.empresaSelecionada.id 
            this.tabPrecoService
                .findAllCombo(0, idempresa, "0", search)
                .then((r) => {
                    this.tabPreco = r.content;
                })
                .catch((e) => {
                    console.error(
                        `Erro ao realizar pesquisa de tabela de preços. Termo: [${q}]`,
                        e
                    );
                })
                .finally((_) => {
                    this.tabPrecoLoading = false;
                    if(isInput){
                        this.getThumbnailSize(isInput);
                    }
                });
        },
        // @84559 - Ao atualizar as tabelas de preço selecionadas, busca os produtos delas
        updateTabPreco(e) {
            this.tabPrecoSelecionadas = e;
            this.carregarDados(1, true);
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage, true);
        },
        updatePaginationSemFotos(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
        },
        onSearch(value) {
            this.filtros.search = this.removeAcentos(value);
            this.carregarDados(1, true);
        },
        carregarDados(currentPage = 1, isInput = false) {
            if(!isInput) return;

            this.isLoading = true;

            if (currentPage == 1 && this.pagination.currentPage != 1) {
                this.pagination.resetPagination = true;
            }

            if(!this.empresaSelecionada){
                if(this.$store.state.user.admin){
                    this.empresaSelecionada = {id: -1, rsocial: "Todos"}
                } else {
                    this.empresaSelecionada = {id: 0, rsocial: "Sem vínculo"}
                }
            }

            this.filtros.idempresa = this.empresaSelecionada.id ? this.empresaSelecionada.id : 0
            this.filtros.idtabpreco = this.tabPrecoSelecionadas.map(({idtabpreco}) => idtabpreco);
            this.service
                .findAll(
                    currentPage - 1,
                    this.pagination.perPage,
                    this.sort,
                    this.filtros
                )
                .then((value) => {
                    this.pagination.totalRows = value.totalElements;
                    if (value.content) {
                        this.allprodutos = this.mapItems(value.content);
                    }
                    this.isEmpty = this.allprodutos.length <= 0;
                })
                .catch((e) => {
                    console.error("Erro ao carregar listagem de pedidos.", e);
                })
                .finally((_) => {
                    this.pagination.resetPagination = false;
                    this.isLoading = false;
                });
        },
        /* 
            @86351 - Metodo para mapear os itens e trazer para cada produto, suas diferentes grades,
            empresa, tabela de preco, valor do produto e saldo
        */ 
        mapItems(produtos) {
            produtos = produtos.map((p) => {
                if(p.foto != null) {
                    let texto = "" + p.foto;
                    p.foto = texto.replace("/catalogo/", "/catalogo/thumbnail_");
                }

                return {
                    id: p.idproduto,
                    idprodutoerp: p.idprodutoerp,
                    produtodescricao: p.descricao ? p.descricao : "---",
                  /*  grade_linha: p.grade.gradelinha.descricao ?
                    p.grade.gradelinha.descricao : "---",
                    grade_coluna: p.grade.gradecoluna.descricao ?
                    p.grade.gradecoluna.descricao : "---",*/
                    empresanome: p.empresa.nome ?
                    p.empresa.nome : "---",
                    saldo: p.saldoproduto.saldo,
                    referencia: p.referencia ? p.referencia : "---",
                    marca: p.marca,
                    tabelapreco: p.tabpreco.descricao ?
                    p.tabpreco.descricao : "---",
                    valor1: p.asstabprecoproduto.valor1,
                    codbarras: p.codbarras,
                    foto: {
                        url: p.foto,
                    } // @86351 - caso o filtro.mostrarFotos esteja inativado, sera vazio
                };
            });
            return produtos;
        },
    }
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: 100%;
    min-height: calc(100% - 50px);
    position: relative;

    .page {
        position: relative;
        padding-left: 0;

        .filters-bar {
            display: flex;
            padding: 20px 0 10px 0;
            .filters-bar-form {
                flex-grow: 1;
            }
            .filters-bar-actions {
                display: flex;
                padding-bottom: 2px;
                align-items: stretch;
            }

            @media screen and (min-width: 851px) {
                .filters-bar-actions {
                    align-self: center;
                    margin-left: 10px;
                }
            }
            @media screen and (max-width: 850px) {
                flex-direction: column;
                .filters-bar-actions {
                    align-self: center;
                    margin-top: 10px;
                }
            }
        }
    }
    .produto-table {
        font-size: 13px;
    }

    .image-box{
        flex-grow: 0;
        margin: -5px;
        
        .image-as-background {
            background-repeat: no-repeat;
            background-position: center;
            background-size: contain;
        }
    }
    .mt-2-custom {
        margin-top: 35px;
    }
    @media screen and (max-width: 930px) {
        .mt-2-custom {
            margin-top: 0;
            .float-right {
                float: left;
                margin: 15px 15px 0 15px;
            }
        }
        .column {
            width: 100%
        }
    }
}
</style>